// import { RetryPlugin } from '@module-federation/retry-plugin';
import { createRemoteAppComponent, loadRemoteApp } from '@module-federation/bridge-react';
import { Spin, Button, Card, Typography } from 'antd';

const { Title, Text } = Typography;

const FallbackErrorComp = ({ resetErrorBoundary, size = 'large' }) => {
  const isSmall = size === 'small';

  if (isSmall) {
    return (
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 8,
          padding: '8px',
        }}
      >
        <Text type="secondary">Couldn't load this module.</Text>
        <Button size="small" type="primary" onClick={resetErrorBoundary}>
          Retry
        </Button>
      </div>
    );
  }

  return (
    <div
      style={{
        height: '100vh',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#f5f6fa',
        padding: '16px',
      }}
    >
      <Card
        style={{
          maxWidth: 500,
          width: '100%',
          textAlign: 'center',
          borderRadius: 12,
        }}
      >
        <Title level={4}>⚠️ Something went wrong</Title>

        <Text type="secondary">
          We couldn't load this module. This might be a temporary issue.
        </Text>

        <div style={{ marginTop: 16 }}>
          <Button type="primary" onClick={resetErrorBoundary}>
            Retry
          </Button>
        </div>
      </Card>
    </div>
  );
};

const getFallbackComp = (size = 'large') => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: size === 'small' ? 'auto' : '100vh',
      padding: size === 'small' ? '8px' : 0,
      width: '100%',
    }}
  >
    <Spin size={size} />
  </div>
);

const FallbackComp = getFallbackComp('large');

const EasycollectPrePaymentApp = createRemoteAppComponent({
  loader: () => import('dashUI/PrePaymentApp'),
  fallback: FallbackErrorComp,
  loading: FallbackComp,
});

const EasycollectPostPaymentApp = createRemoteAppComponent({
  loader: () => import('dashUI/PostPaymentApp'),
  fallback: FallbackErrorComp,
  loading: FallbackComp,
});

const OTPInput = createRemoteAppComponent({
  loader: async () => await import('merchant/otp-input'),
  fallback: (props) => <FallbackErrorComp {...props} size="small" />,
  loading: getFallbackComp('small'),
});



export {
  EasycollectPrePaymentApp,
  EasycollectPostPaymentApp,
  OTPInput,
};
